function isAppleDevice() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  const iOS = /iPad|iPhone|iPod/.test(ua)
  const iPadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return iOS || iPadOs
}

export function buildMapsUrl({ name = '', address = '', lat, lng } = {}) {
  const label = [name, address].filter(Boolean).join(' ')
  if (lat != null && lng != null && !Number.isNaN(Number(lat))) {
    const query = encodeURIComponent(label || `${lat},${lng}`)
    return isAppleDevice()
      ? `https://maps.apple.com/?ll=${lat},${lng}&q=${query}`
      : `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
  }
  const fallback = encodeURIComponent(label)
  if (!fallback) return ''
  return isAppleDevice()
    ? `https://maps.apple.com/?q=${fallback}`
    : `https://www.google.com/maps/search/?api=1&query=${fallback}`
}

export async function copyText(value) {
  const text = String(value || '')
  if (!text) return false
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
